<template>
    <div class="card login-container">

        <div class="card-header">
            <p class="card-header-title">{{ trans.element.login }}</p>
        </div>

        <div class="card-content field-label-container">
            <form method="POST" @submit.prevent="submit" @input="clearValidation"
                  :action="action" novalidate
            >

                <slot><!--CSRF token--></slot>

                <div class="field is-horizontal">
                    <label for="email" class="field-label is-normal">
                        {{ trans.element.email }}
                    </label>
                    <div class="field-body">
                        <div class="field">
                            <div class="control">
                                <input id="email" v-model="form.email"
                                       class="input" :class="[errors.email ? 'is-danger' : '']"
                                       type="email" name="email" required
                                       autocomplete="email" autofocus
                                       :disabled="waiting"
                                >
                            </div>
                            <p v-show="errors.email" class="help is-danger">
                                {{ errors.email }}
                            </p>
                        </div>
                    </div>
                </div>

                <div class="field is-horizontal">
                    <label for="password" class="field-label is-normal">
                        {{ trans.element.password }}
                    </label>
                    <div class="field-body">
                        <div class="field">
                            <div class="control">
                                <input id="password" v-model="form.password"
                                       class="input" :class="[errors.password ? 'is-danger' : '']"
                                       type="password" name="password" required
                                       autocomplete="current-password"
                                >
                            </div>
                            <p v-show="errors.password" class="help is-danger">
                                {{ errors.password }}
                            </p>
                        </div>
                    </div>
                </div>

                <div class="field is-horizontal is-flex-mobile mb-0">
                    <div class="field-label"></div>
                    <div class="field-body">
                        <div class="field">
                            <div class="control">
                                <input
                                    type="checkbox"
                                    name="remember"
                                    id="remember"
                                    v-model="form.remember"
                                    class="is-checkradio is-info is-small"
                                >
                                <label for="remember" class="checkbox">
                                    {{ trans.element.remember_me }}
                                </label>
                            </div>
                        </div>
                        <div class="field forgot-password">
                            <div class="control has-text-right-tablet">
                                <a
                                    v-if="password_request"
                                    :href="password_request"
                                    class="is-size-7"
                                >
                                    {{ trans.element.forgot_password }}
                                </a>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="field is-horizontal login-buttons">
                    <div class="field-label"></div>
                    <div class="field-body">
                        <div class="field">
                            <p class="control">
                                <button type="submit" class="button is-info"
                                    :class="[isLoading ? 'is-loading' : '']"
                                    :disabled="isLoading"
                                >
                                    {{ trans.element.login }}
                                </button>
                            </p>
                        </div>
                        <p v-show="errors.unexpected" class="help is-danger">
                            {{ errors.unexpected }}
                        </p>
                    </div>
                </div>

                <div class="field is-horizontal">
                    <div class="field-label"></div>
                    <div class="field-body">
                        <p v-html="registerLabel"></p>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
    import { axiosForm } from '../mixins/axiosFormMixin.js';

    export default {
        mixins: [axiosForm],
        props: {
            password_request: String || NaN,
            register_request: String,
            is_admin24_context: Boolean
        },
        data() {
            return {
                form: {
                    email: null,
                    password: null,
                    remember: null
                },
                waiting: null,

                okReport: 'Пользователь вошёл',
                failReport: 'Ошибка входа пользователя',
            }
        },
        methods: {
            fillBx24LoginForm() {
                if (!isBx24Context) {
                    return;
                }

                /*
                 * внутри колбэка this - это не этот компонент, поэтому
                 * дополнительная переменная
                 */
                let thisComponent = this;
                thisComponent.form.email = this.trans.element.loading_from_portal;
                thisComponent.waiting = true;

                new Promise(function(resolve, reject) {
                    BX24.init( () => { resolve() });
                })
                .then( () => {
                    return new Promise(function(resolve, reject) {
                        BX24.callMethod('user.current', {}, (result) => resolve(result) );
                    })
                })
                .then( (result) => {
                    thisComponent.form.email = result.data().EMAIL;
                    thisComponent.waiting = null;
                });
            }
        },
        created() {
            this.fillBx24LoginForm();
        },
        computed: {
            registerLabel() {
                const blankTarget = this.is_admin24_context ? 'target="_blank"' : '';

                return this.trans.element.register_label.replace(':link', this.register_request).replace(':blank', blankTarget);
            },
        },
    }
</script>
